import { Theme } from '@mui/material';
import zIndex from '@mui/material/styles/zIndex';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  uploadField: {
    height: '99px',
    width: '100%',
    backgroundColor: '#EAEFFF',
    marginTop: '10px',
    borderRadius: '9px',
    flexDirection: 'column',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
    padding: '12px',
  },
  registeredEventsHeading: {
    textAlign: 'start',
    fontSize: '20px !important',
    color: theme.palette.KenColors.ClientBlack2,
    fontWeight: '500 !important',
    margin: '2px 2px 17px 5px !important',
    '@media (max-width: 1440px)': {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1440px)': {
      fontSize: '14px !important',
    },
  },
  registeredEventsHeadingmobile: {
    textAlign: 'start',
    fontSize: '16px !important',
    color: theme.palette.KenColors.ClientBlack2,
    fontWeight: '500 !important',
    margin: '2px 2px 2px 5px !important',
    '@media (max-width: 1440px)': {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '14px !important',
    },
  },
    registeredEventsSubHeadingmobile: {
    textAlign: 'start',
    fontSize: '14px !important',
    color: theme.palette.KenColors.ClientBlack2,
    fontWeight: '500 !important',
    margin: '2px 2px 2px 5px !important',
    marginTop :'20px !important',
    '@media (max-width: 1440px)': {
      fontSize: '14px !important',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '14px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '14px !important',
    },
  },
  registerEventsContainer1 : {
    boxShadow: 'none !important',
    height : 'calc(100vh - 132px)',
    padding : '16px',
    textAlign : 'start',
    borderRadius: '12px !important',
    // border: '1px solid #E6E6E8',
    background: '#FFFFFF',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  impactContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    flex: 1,
  },
  impactHeader: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  impactHeading: {
    fontSize: '16px',
    fontWeight: '500 !important',
    color: '#373A45',
  },
  impactList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  impactCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 14px',
    borderRadius: '12px',
    border: '1px solid #E6E6E8',
    background: '#FFFFFF',
  },
  impactCardClickable: {
    cursor: 'pointer',
    transition: 'background 0.2s ease, border-color 0.2s ease',
    '&:hover': {
      background: '#F6F8FB',
      borderColor: '#D7DAE2',
    },
  },
  impactIconWrap: {
    height: '40px',
    width: '40px',
    borderRadius: '12px',
    background: '#F3F4F6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  impactIcon: {
    color: '#373A45',
    fontSize: '20px !important',
  },
  impactTextWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    flex: 1,
    minWidth: 0,
  },
  impactTitle: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: '#373A45',
  },
  impactSubtitle: {
    fontSize: '13px',
    fontWeight: '400 !important',
    color: '#6B7280',
  },
  impactArrow: {
    color: '#373A45',
    fontSize: '18px !important',
  },
  impactOrRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    margin: '8px 0 4px',
  },
  impactOrLine: {
    flex: 1,
    borderColor: '#E6E6E8',
  },
  impactOrText: {
    fontSize: '12px',
    color: '#6B7280',
    fontWeight: '500 !important',
  },
  volunteerCard: {
    borderRadius: '12px',
    border: '1px solid #D6E4FF',
    background: '#F7FAFF',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
    textAlign: 'center',
    marginTop: 'auto',
  },
  volunteerIconWrap: {
    height: '40px',
    width: '40px',
    borderRadius: '12px',
    background: '#FFFFFF',
    border: '1px solid #D6E4FF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  volunteerIcon: {
    color: '#2C60AA',
    fontSize: '20px !important',
  },
  volunteerTitle: {
    fontSize: '16px',
    fontWeight: '600 !important',
    color: '#1F2937',
  },
  volunteerSubtitle: {
    fontSize: '13px',
    fontWeight: '400 !important',
    color: '#6B7280',
  },
  registerEventsContainer: {
    padding: '0px 22px',
    height: '15vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    boxShadow: 'none !important',
    [theme.breakpoints.up('xxl')]: {
      height: '35vh',
    },
    '@media (max-width: 1536px)': {
      height: '30.5vh !important',
    },
    '@media (min-width: 1920px) and (max-width: 2000px)': {
      height: '45vh',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '20vh !important',
    },
  },
  cardContainerII: {
    background: theme.palette.KenColors.kenWhite,
    padding: '20px 20px 20px 20px !important',
    boxShadow: 'none !important',
    height: '100vh',
    [theme.breakpoints.up('xxl')]: {
      height: '83.5vh',
    },
    '@media (max-width: 1600px)': {
      height: '83.5vh !important',
    },
    '@media (max-width: 1360px)': {
      height: '100vh !important',
    },
    '@media (max-width: 1536px)': {
      height: '83.5vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
    borderRadius: '9px !important',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  cardContainer: {
    background: theme.palette.KenColors.kenWhite,
    padding: '20px 20px 20px 20px !important',
    boxShadow: 'none !important',
    height: '100vh',
    [theme.breakpoints.up('xxl')]: {
      height: '83.5vh',
    },
    '@media (max-width: 1600px)': {
      height: '83.5vh !important',
    },
    '@media (max-width: 1360px)': {
      height: '100vh !important',
    },
    '@media (max-width: 1536px)': {
      height: '83.5vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '81vh !important',
    },
    [theme.breakpoints.down('sm')]: {
      height: 'auto !important',
    },
    borderRadius: '9px !important',
    overflowX: 'hidden',
    overflowY: 'auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'start',
  },
  cardContainerMobile: {
    background: theme.palette.KenColors.kenWhite,
    // padding: '20px 20px 20px 20px !important',
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    // display: 'flex',
    // justifyContent: 'space-between',
    alignItems: 'start',
  },
  divider: {
    borderBottom: '1px solid #B8C0DA',
    marginBottom: '10px',
    marginTop: '10px',

  },
  gridItem: {
    border: '1px solid #BFCEFF',
    borderRadius: '12px !important',
    height: '148px',
    '@media (min-width: 1920px) and (max-width: 1940px)': {
      height: '15vh !important',
    },
  },
  gridItem1: {
    borderRadius: '12px !important',
    backgroundColor: '#F6F8FB',
  },
  gridItemImage: {
    width: '100%',
    aspectRatio: '16 / 7',
    minHeight: '140px',
    maxHeight: '190px',
    borderRadius: '12px 12px 0 0 !important',
    marginBottom: '12px',
    padding: '10px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      minHeight: '170px',
      maxHeight: '220px',
    },
  },
  cellBanner: {
    color: '#585A64',
    fontSize: '12px',
    fontWeight: '500 !important',
    background: '#FFFFFF',
    padding: '4px 12px',
    borderRadius: '50px',
    width: 'fit-content',
  },
  gridItemContent1: {
    padding: '4px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  gridItemTitle1: {
    textAlign: 'left',
    fontSize: '14px',
    fontWeight: '500 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
    '@media (min-width: 280px) and (max-width: 600px)': {
      fontSize: '12px !important',
    },
  },
  gridItemText: {
    textAlign: 'left',
    fontSize: '10.5px',
    fontWeight: '400',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '9.5px !important',
    },
  },
  gridItemFooter: {
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '10px',
    alignItems: 'center',
  },
  gridItemFooterText: {
    fontSize: '12px',
    fontWeight: '500 !important',
  },
  registedredCardTitle: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: 'rgba(55, 58, 69, 1)',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  cellText: {
    fontSize: '12px',
    fontWeight: '400 !important',
    color: 'rgba(55, 58, 69, 1)',
  },
  cellBg: {
    background: 'rgba(255, 255, 255, 1)',
    border: '1px solid rgba(230, 230, 232, 1)',
    padding: '4px 12px',
    borderRadius: '50px',
  },
  cellTag: {
    height: '8px',
    width: '8px',
    borderRadius: '50px',
    background: 'rgba(220, 89, 89, 1)',
  },
  cellsTags: {
    borderRadius: '50px',
    height: 'auto',
    padding: '4px 12px',
    fontSize: '14px',
    fontWeight: '500 !important',
    maxWidth: 'fit-content',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
    '@media (min-width: 280px) and (max-width: 600px)': {
      borderRadius: '5px !important',
      marginLeft: '5px !important',
    },
  },
  cellImg: {
    height: '94px',
    width: '94px',
    borderRadius: '4px',
    objectFit: 'cover',
  },
  dateInprogress: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: 'rgba(55, 58, 69, 1)',
    fontStyle: 'italic',
  },
  cardContainerReg: {
    background: 'rgba(246, 248, 251, 1)',
    borderRadius: '4px',
    padding: '12px',
    cursor: 'pointer',
  },
hostEventCard: {
  backgroundColor: "#2C60AA !important", // ✅ use this instead
  padding: '16px 20px',
  border: "1px solid #684601",
  borderRadius: '9px !important',
  boxShadow: 'none !important',
  cursor: 'pointer',
  height: '31vh',
},
  hostHeading: {
    textAlign: 'start',
    fontSize: '16px !important',
    color: "#5B4200",
    fontWeight: '500 !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  hostAnEventBanner: {
    height: '147px',
    width: 'auto',
    margin: '30px 0px',
    '@media (max-width: 1440px)': {
      height: '117px',
      margin: '30px 0px',
    },
    '@media (max-width: 1600px)': {
      height: '110px !important',
      margin: '10px 0px',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '7vh !important',
    },
  },
  profileImg: {
    height: '24px',
    width: '24px',
    borderRadius: '50px',
    objectFit: 'cover',
  },
  profileName: {
    color: '#373A45',
    fontSize: '12px',
    fontWeight: '500 !important',
  },
  detailsBanner: {
    width: '100%',
    aspectRatio: '16 / 5',
    minHeight: '220px',
    maxHeight: '380px',
    padding: '24px',
    marginBottom: '20px',
    position: 'relative',
    borderRadius: '12px',
    overflow: 'hidden',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('md')]: {
      aspectRatio: '16 / 8',
      minHeight: '180px',
      maxHeight: '260px',
      padding: '16px',
    },
    '&:after': {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      content: '""',
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 19.44%, rgba(0, 0, 0, 0.8) 85.59%, #000000 110%)',
    },
  },
  bannerDate: {
    color: 'white',
    fontSize: '16px',
    fontWeight: '500 !important',
  },
  bannerTitle: {
    color: '#FFFFFF',
    fontSize: '24px',
    fontWeight: '600 !important',
  },
  bannerCell: {
    color: '#373A45',
    fontSize: '16px',
    fontWeight: '500 !important',
    background: '#FFFFFF',
    padding: '4px 12px',
    borderRadius: '50px',
  },
  goalContainer: {
    background: '#EAEFFF',
    padding: '24px',
    borderRadius: '8px',
    color: '#373A45',
    maxWidth: '480px',
    [theme.breakpoints.down('md')]: {
      padding : '12px'
    },
  },
  goalContainerHead: {
    fontSize: '16px',
    color: '#373A45',
    fontWeight: '500 !important',
  },
  goalContainerAmount: {
    fontSize: '40px',
    color: '#373A45',
    fontWeight: '600 !important',
  },
  aboutHeader: {
    color: '#373A45',
    fontSize: '16px',
    fontWeight: '500 !important',
  },
  aboutContent: {
    color: '#373A45',
    fontSize: '16px',
    fontWeight: '400 !important',
    textAlign: 'start',
  },
  filterBtn: {
    background: `${theme.palette.KenColors.ClientPrimaryGrey} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    boxShadow: 'none !important',
    fontSize: '0.8rem !important',
    padding: '6px 20px !important',
    borderRadius: '8px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem !important',
      padding: '2px 14px !important',
      borderRadius: '6px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '6px 15px !important',
      fontSize: '10px !important',
    },
  },
  createCampBtn: {
    background: `${theme.palette.KenColors.ClientPrimaryGradientI} !important`,
    color: `${theme.palette.KenColors.ClientGrey2} !important`,
    boxShadow: 'none !important',
    fontSize: '0.8rem !important',
    padding: '6px 20px !important',
    borderRadius: '8px !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8rem !important',
      padding: '2px 14px !important',
      borderRadius: '6px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      padding: '6px 15px !important',
      fontSize: '10px !important',
    },
  },
  createCampaignBtnIphoneSE: {
    '@media only screen and (max-width: 375px) and (max-height: 667px)': {
      marginBottom: '1rem !important',
    },
    '@media only screen and (max-width: 320px) and (max-height: 568px)': {
      marginBottom: '1rem !important',
    },
  },
  campaignCards: {
    borderRadius: '12px',
    background: theme.palette.KenColors.ClientGrey2,
    cursor: 'pointer',
    overflow: 'hidden',
  },
  campaignCardsBanner: {
    borderRadius: '12px 12px 0 0',
    width: '100%',
    aspectRatio: '16 / 7',
    minHeight: '150px',
    maxHeight: '210px',
    padding: '10px',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    [theme.breakpoints.down('sm')]: {
      minHeight: '170px',
      maxHeight: '240px',
    },
  },
  campaignCardsTitle: {
    fontSize: '14px',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
  },
  campaignCategory: {
    fontSize: '12px',
    fontWeight: '500 !important',
    color: '#585A64',
    border: '1px solid #6576B0',
    padding: '2px 12px',
    background: '#FFFFFF',
    borderRadius: '50px',
  },
  campaignDate: {
    color: '#333333',
    fontSize: '14px',
    fontWeight: '400 !important',
  },
  campaignGoal: {
    fontSize: '16px',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
    background: '#EDEEF1',
    width: '100%',
    padding: '6px 0px',
    borderRadius: '50px',
  },
  rejectedContainer: {
    background: '#F1BFBF',
    borderRadius: '8px',
    padding: '12px',
    width: '60%',
  },
  personCount: {
    color: '#2C60AA',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  noFundsHeader: {
    color: '#373A45',
    fontSize: '20px',
  },
  cellsContainer: {
    background: '#E8EBF3',
    padding: '10px 22px',
    borderRadius: '50px',
  },
  cellTextData: {
    fontSize: '16px',
    color: '#2C60AA',
    fontWeight: '500 !important',
  },
  closeCampaignHead: {
    fontSize: '20px',
    fontWeight: '500 !important',
    color: theme.palette.KenColors.ClientBlack2,
  },
  closeCampaignSubHead: {
    fontSize: '16px',
    fontWeight: '400 !important',
    color: theme.palette.KenColors.ClientBlack2,
  },
  label: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    color: '#373A45 !important',
    marginBottom: '6px !important',
  },
  getStarted: {
    fontSize: '14px',
    fontWeight: '600 !important',
    color: '#373A45',
  },
  getStartedDesc: {
    fontSize: '14px',
    fontWeight: '400 !important',
    color: '#373A45',
  },
  intrestedBg: {
    background: '#F6F8FB',
    borderRadius: '8px',
    padding: '12px 16px',
  },
  intrestedImg: {
    borderRadius: '50px',
    objectFit: 'cover',
  },
  intrestedName: {
    fontSize: '16px',
    fontWeight: '500 !important',
    color: '#373A45',
  },
  intrestedCap: {
    fontSize: '16px',
    fontWeight: '400 !important',
    color: '#585A64',
  },
  intrestedHead: {
    fontSize: '20px',
    fontWeight: '500 !important',
    color: '#373A45',
  },
}));
